'use client';

import { forwardRef, ForwardRefRenderFunction, useState } from 'react';

import cn from '@/helpers/cn';

import css from './style.module.scss';

interface Props {
	text: string;
	className?: string;
	size?: 'small' | 'large';
	isAccent?: boolean;
}

const EmailButton: ForwardRefRenderFunction<HTMLButtonElement, Props> = (
	{ text, className = '', size = 'large', isAccent = false },
	ref
) => {
	const [copied, setCopied] = useState(false);

	const copyToClipboard = async () => {
		try {
			await navigator.clipboard.writeText(text);
			setCopied(true);

			setTimeout(() => setCopied(false), 2000);
		} catch (err) {
			console.error('Failed to copy: ', err);
		}
	};

	return (
		<button
			ref={ref}
			className={cn(
				css.button,
				className,
				css[size],
				isAccent ? css.accent : '',
				copied ? css.blink : ''
			)}
			onClick={copyToClipboard}
		>
			<p className={css.email}>{text}</p>

			<svg
				className={css.icon}
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M5.6975 10.625C5.40958 10.625 5.16938 10.5288 4.97688 10.3363C4.78438 10.1438 4.68792 9.90354 4.6875 9.61563V2.88438C4.6875 2.59688 4.78396 2.35667 4.97688 2.16375C5.16979 1.97083 5.41 1.87458 5.6975 1.875H10.5531C10.8406 1.875 11.0808 1.97125 11.2738 2.16375C11.4667 2.35625 11.5629 2.59646 11.5625 2.88438V9.61563C11.5625 9.90313 11.4663 10.1431 11.2738 10.3356C11.0813 10.5281 10.8408 10.6246 10.5525 10.625H5.6975ZM3.8225 12.5C3.53458 12.5 3.29437 12.4038 3.10187 12.2113C2.90937 12.0188 2.81292 11.7785 2.8125 11.4906V4.13438H3.4375V11.4906C3.4375 11.5865 3.4775 11.6746 3.5575 11.755C3.6375 11.8354 3.72562 11.8754 3.82187 11.875H9.30313V12.5H3.8225Z"
					fill="white"
				/>
			</svg>
		</button>
	);
};

export default forwardRef(EmailButton);
